import { useEffect, useState } from 'react';
import backendApi from './backendApi';
import { ClimateLocationsDto } from '../components/InputFieldsContainer';

export const useClimateLocations = (
    backendApi: backendApi | undefined,
    market: string
): {
    data: ClimateLocationsDto | undefined;
    loading: boolean;
    error: string | undefined;
} => {
    const [data, setData] = useState<ClimateLocationsDto>();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | undefined>(undefined);

    useEffect(() => {
        if (!backendApi) {
            return;
        }
        const fetchClimateLocations = async () => {
            try {
                const climateLocationsResponse =
                    await backendApi.getClimateLocations(market);
                setData(climateLocationsResponse);
            } catch (error) {
                setError(
                    error instanceof Error ? error.message : String(error)
                );
            } finally {
                setLoading(false);
            }
        };
        fetchClimateLocations();
    }, [backendApi, market]);

    return { data, loading, error };
};
